import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Text } from "../../../components/Text";
import "./style.css";
import { ReactComponent as EditIcon } from "../../../svg/edit.svg";
import { CustomButton } from "../../../components/CustomButton";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import {
  API_GET_ALL_IPCONFIGS,
  API_ADD_IPCONFIG,
  API_UPDATE_IPCONFIG,
  API_DELETE_IPCONFIG,
} from "../../../api/iptable.service";

const IpWhitelisting = () => {
  const [data, setData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [newIP, setNewIP] = useState("");
  const [isModalVisible, setModalVisible] = useState(false);

  // Fetch all IP configurations on component mount
  useEffect(() => {
    fetchIPConfigs();
  }, []);

  const fetchIPConfigs = async () => {
    try {
      const ipConfigs = await API_GET_ALL_IPCONFIGS();
      setData(
        ipConfigs.map((config, index) => ({
          sno: index + 1,
          id: config.id,
          companyId: config.companyId,
          companyName: config?.company?.companyName,
          allowedIPs: config.whitelistIps || [],
        }))
      );
    } catch (error) {
      console.error("Error fetching IP configurations:", error);
    }
  };

  const openModal = (rowData) => {
    setSelectedRow(rowData);
    setModalVisible(true);
  };

  const closeModal = () => {
    setSelectedRow(null);
    setNewIP("");
    setModalVisible(false);
  };

  const addIP = async () => {
    if (newIP.trim()) {
      try {
        const updatedIPs = [...selectedRow.allowedIPs, newIP.trim()];
        await API_UPDATE_IPCONFIG(selectedRow.id, { whitelistIps: updatedIPs });
        setData((prevData) =>
          prevData.map((row) =>
            row.id === selectedRow.id ? { ...row, allowedIPs: updatedIPs } : row
          )
        );
        setNewIP("");
      } catch (error) {
        console.error("Error adding IP:", error);
      }
    }
  };

  const deleteIP = async (ipToDelete) => {
    try {
      const updatedIPs = selectedRow.allowedIPs.filter(
        (ip) => ip !== ipToDelete
      );
      await API_DELETE_IPCONFIG(selectedRow.id, { whitelistIps: updatedIPs });
      setData((prevData) =>
        prevData.map((row) =>
          row.id === selectedRow.id ? { ...row, allowedIPs: updatedIPs } : row
        )
      );
    } catch (error) {
      console.error("Error deleting IP:", error);
    }
  };

  const renderAllowedIPs = (rowData) => (
    <div>
      {rowData.allowedIPs.map((ip, index) => (
        <span key={index} className="chip">
          {ip}
        </span>
      ))}
    </div>
  );

  const rowClassName = (rowData, index) => (index === 0 ? "highlight-row" : "");

  const renderActions = (rowData) => (
    <CustomButton
      varient="icon-button"
      icon={<EditIcon />}
      onClick={() => openModal(rowData)}
      style={{ padding: "0px" }}
    />
  );

  return (
    <>
      <Text type={"heading"}>IP Whitelisting</Text>
      <div className="datatable-demo">
        <DataTable
          value={data}
          responsiveLayout="scroll"
          rowClassName={rowClassName}
          className="skalebot-table"
        >
          <Column field="sno" header="Sno" style={{ minWidth: "100px" }} />
          <Column
            field="companyName"
            header="Company Name"
            style={{ width: "30%" }}
          />
          <Column
            header="Allowed IPs"
            body={renderAllowedIPs}
            style={{ width: "50%" }}
          />
          <Column
            header="Actions"
            body={renderActions}
            style={{ width: "5ch" }}
          />
        </DataTable>
      </div>

      {selectedRow && (
        <Dialog
          header={
            selectedRow.companyName === "All companies (Global)"
              ? "Add Global IP Address"
              : "Edit IP Address"
          }
          visible={isModalVisible}
          onHide={closeModal}
          footer={
            <div>
              <CustomButton
                label="Cancel"
                onClick={closeModal}
                className="p-button-text"
              />
              <CustomButton label="Save" onClick={closeModal} />
            </div>
          }
        >
          <div className="modal-content">
            <div className="field">
              <label htmlFor="companyName">Company Name</label>
              <InputText
                id="companyName"
                value={selectedRow.companyName}
                disabled
              />
            </div>
            <div className="field">
              <label htmlFor="newIP">Add New IP</label>
              <div className="add-ip">
                <InputText
                  id="newIP"
                  value={newIP}
                  onChange={(e) => setNewIP(e.target.value)}
                />
                <CustomButton label="Add" onClick={addIP} />
              </div>
            </div>
            <div className="field">
              <label>Allowed IPs</label>
              <DataTable
                value={selectedRow.allowedIPs.map((ip, index) => ({
                  sno: index + 1,
                  ip,
                }))}
              >
                <Column field="sno" header="Sno" />
                <Column field="ip" header="Allowed IPs" />
                <Column
                  header="Action"
                  body={(rowData) => (
                    <Button
                      icon="pi pi-trash"
                      className="p-button-text"
                      onClick={() => deleteIP(rowData.ip)}
                    />
                  )}
                />
              </DataTable>
            </div>
          </div>
        </Dialog>
      )}
    </>
  );
};

export default IpWhitelisting;
